import React from 'react';
import { FingerprintOutlined } from '@mui/icons-material';
import { Alert, Card, FieldGroup, RadioGroup, Row, Stack, Text, TextInput } from 'library/ui';
import { Colors } from 'library';

export function SponsorshipSection({
    workerName,
    needsNewScreening,
    sponsorshipPending,
    sponsorScreening,
    onSponsorScreeningChange,
    oca,
    onOcaChange,
    hadOcaOnFile,
}: {
    workerName: string;
    needsNewScreening: boolean;
    sponsorshipPending: boolean;
    sponsorScreening: string | null;
    onSponsorScreeningChange: (value: string) => void;
    oca: string;
    onOcaChange: (value: string) => void;
    hadOcaOnFile: boolean;
}) {
    if (!needsNewScreening) {
        return null;
    }
    if (sponsorshipPending) {
        return (
            <Alert variant="info">
                <Text size="xs">
                    A sponsored screening is already underway for {workerName}. Their status will update here as it
                    progresses — no action is needed from you.
                </Text>
            </Alert>
        );
    }
    return (
        <Card tone="secondary" padding="md">
            <Stack gap="md">
                <Row gap="sm" align="center">
                    <FingerprintOutlined sx={{ fontSize: 20, color: Colors.secondary }} />
                    <Text weight="semibold">{workerName} needs a new screening</Text>
                </Row>
                <FieldGroup
                    required
                    label="Do you want to sponsor this teacher&rsquo;s screening under your OCA number?"
                    subtext="Tandem will cover the cost of the screening. There is no cost to you to sponsor."
                >
                    <RadioGroup
                        options={[
                            { value: 'yes', label: 'Yes' },
                            { value: 'no', label: 'No' },
                        ]}
                        value={sponsorScreening}
                        onChange={onSponsorScreeningChange}
                    />
                </FieldGroup>
                {sponsorScreening === 'yes' && (
                    <FieldGroup
                        required
                        label="Confirm your OCA number"
                        subtext={
                            hadOcaOnFile
                                ? 'This is the OCA number on file for your location — correct it here if it looks wrong.'
                                : `It looks like we don't have your OCA number on file. Please enter it here to sponsor ${workerName}.`
                        }
                    >
                        <TextInput value={oca} onChange={onOcaChange} placeholder="OCA number" fullWidth />
                    </FieldGroup>
                )}
            </Stack>
        </Card>
    );
}
